import { render } from "./FilesNotAcceptedModal.vue?vue&type=template&id=f2e01412&scoped=true"
import script from "./FilesNotAcceptedModal.vue?vue&type=script&lang=js"
export * from "./FilesNotAcceptedModal.vue?vue&type=script&lang=js"

import "./FilesNotAcceptedModal.vue?vue&type=style&index=0&id=f2e01412&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e01412"]])

export default __exports__